<template>
  <div class="share-">
    <span>{{ $t("homepage.shareLink") }}:</span>
    <ul>
      <li v-for="item of shares">
        <el-popover
          placement="top"
          width="80"
          popper-class="share-popover"
          trigger="hover"
        >
          <div>
            <span v-if="item.title">{{ item.title }}</span>
            <template   v-else-if="item.type === 'h5'">
                <div
                class="share-qrcode"
                id="qrcode"
                ref="qrcode"
              ></div>
              <p class="qrcode-text">
              手机扫一扫
              <!-- <svg @click="downloadImage" t="1703554740282" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5992" width="20" height="20"><path d="M230.4 665.6a25.6 25.6 0 1 1 0 51.2h-102.4A128 128 0 0 1 0 588.8v-460.8A128 128 0 0 1 128 0h460.8A128 128 0 0 1 716.8 128v102.4a25.6 25.6 0 1 1-51.2 0v-102.4A76.8 76.8 0 0 0 588.8 51.2h-460.8A76.8 76.8 0 0 0 51.2 128v460.8A76.8 76.8 0 0 0 128 665.6h102.4z m204.8-307.2A76.8 76.8 0 0 0 358.4 435.2v460.8A76.8 76.8 0 0 0 435.2 972.8h460.8a76.8 76.8 0 0 0 76.8-76.8v-460.8A76.8 76.8 0 0 0 896 358.4h-460.8z m0-51.2h460.8A128 128 0 0 1 1024 435.2v460.8a128 128 0 0 1-128 128h-460.8A128 128 0 0 1 307.2 896v-460.8A128 128 0 0 1 435.2 307.2z" fill="#000000" p-id="5993"></path></svg> -->

              <svg @click="downloadImage"  t="1704256376825" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14119" width="20" height="20"><path d="M450.56 820.48c4.48 4.48 10.88 7.04 16.64 8.96C471.04 831.36 475.52 832 480 832s8.96-0.64 12.8-2.56c6.4-1.28 12.16-3.84 16.64-8.96l313.6-313.6c14.08-14.08 14.08-35.84 0-49.92-14.08-14.08-35.84-14.08-49.92 0L512 718.08 512 160C512 142.08 497.92 128 480 128 462.08 128 448 142.08 448 160l0 558.08L186.88 456.96c-14.08-14.08-35.84-14.08-49.92 0-14.08 14.08-14.08 35.84 0 49.92L450.56 820.48zM864 896l-768 0C78.08 896 64 910.08 64 928 64 945.92 78.08 960 96 960l768 0c17.92 0 32-14.08 32-32C896 910.08 881.92 896 864 896z" p-id="14120"></path></svg>
              
              </p>
            </template>
            
            <!-- <img v-else :src="item.url" /> -->
          </div>
          <span slot="reference" @click="openShare(item)">
            <svg
              v-if="item.type === 'link'"
              t="1702696355037"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4307"
              width="22"
              height="22"
              fill="currentColor"
            >
              <path
                d="M563.2 672c-6.4-6.4 0 0 0 0L448 793.6c-57.6 57.6-153.6 57.6-211.2 0-57.6-57.6-64-147.2 0-211.2l121.6-121.6-6.4-6.4-38.4-32-6.4-6.4-121.6 121.6C108.8 614.4 108.8 755.2 192 832s217.6 83.2 300.8 0l121.6-121.6-6.4-6.4-44.8-32z m38.4-294.4c6.4 0 6.4 0 0 0l38.4 38.4 6.4 6.4-230.4 230.4-38.4-51.2 224-224zM531.2 192c83.2-83.2 217.6-83.2 300.8 0 83.2 83.2 83.2 217.6 0 300.8l-121.6 121.6-44.8-44.8 128-128c44.8-44.8 51.2-147.2-6.4-204.8-57.6-57.6-160-57.6-204.8-6.4l-128 128v-6.4l-38.4-38.4-6.4-6.4L531.2 192z"
                p-id="4308"
              ></path>
            </svg>

            <!-- <svg
              v-if="item.type === 'h5'"
              t="1702697509110"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3616"
              width="18"
              height="18"
            >
              <path
                d="M411 71.3c13.6 0 25 11.5 25 25v317.3c0 13.6-11.5 25-25 25H78c-13.6 0-25-11.5-25-25V96.3c0-13.6 11.5-25 25-25h333m0-50H78c-41.3 0-75 33.8-75 75v317.3c0 41.3 33.8 75 75 75h333c41.3 0 75-33.8 75-75V96.3c0-41.3-33.8-75-75-75z m0 567.4c13.6 0 25 11.5 25 25V931c0 13.6-11.5 25-25 25H78c-13.6 0-25-11.5-25-25V613.7c0-13.6 11.5-25 25-25h333m0-50.1H78c-41.3 0-75 33.8-75 75V931c0 41.3 33.8 75 75 75h333c41.3 0 75-33.8 75-75V613.7c0-41.3-33.8-75.1-75-75.1zM944 71.3c13.6 0 25 11.5 25 25v317.3c0 13.6-11.5 25-25 25H611c-13.6 0-25-11.5-25-25V96.3c0-13.6 11.5-25 25-25h333m0-50H611c-41.3 0-75 33.8-75 75v317.3c0 41.3 33.8 75 75 75h333c41.3 0 75-33.8 75-75V96.3c0-41.3-33.8-75-75-75zM631.7 605.9c-13.8 0-25 11.3-25 25v50c0 13.8 11.3 25 25 25 13.8 0 25-11.3 25-25v-50c0.1-13.8-11.2-25-25-25z m147 0c-13.8 0-25 11.3-25 25v147.5c0 13.8 11.3 25 25 25 13.8 0 25-11.3 25-25V630.9c0-13.8-11.3-25-25-25z m144.6 0c-13.8 0-25 11.3-25 25v82.4c0 13.8 11.3 25 25 25 13.8 0 25-11.3 25-25v-82.4c0-13.8-11.3-25-25-25z m0 198.3c-13.8 0-25 11.3-25 25v114.3c0 13.8 11.3 25 25 25 13.8 0 25-11.3 25-25V829.2c0-13.7-11.3-25-25-25z m-291.6-31.9c-13.8 0-25 11.3-25 25v146.3c0 13.8 11.3 25 25 25 13.8 0 25-11.3 25-25V797.3c0.1-13.7-11.2-25-25-25z m147 66.6c-13.8 0-25 11.3-25 25v79.7c0 13.8 11.3 25 25 25s25-11.3 25-25v-79.7c0-13.8-11.3-25-25-25z"
                p-id="3617"
              ></path>
            </svg> -->

            <svg
              v-if="item.type === 'wx' || item.type === 'h5'"
              t="1702696422339"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="5409"
              width="28"
              height="28"
            >
              <path
                d="M615.904 388.48c8.8 0 17.536 0.64 26.176 1.6-23.52-109.536-140.608-190.912-274.272-190.912C218.4 199.2 96 301.056 96 430.4c0 74.656 40.736 135.936 108.768 183.488l-27.2 81.792 95.04-47.648c33.984 6.72 61.28 13.632 95.2 13.632 8.544 0 16.992-0.416 25.376-1.088a202.496 202.496 0 0 1-8.384-56.96c0-118.752 101.984-215.136 231.104-215.136zM469.76 314.784c20.48 0 34.016 13.472 34.016 33.92 0 20.352-13.536 34.016-34.016 34.016-20.384 0-40.832-13.664-40.832-34.016 0-20.448 20.448-33.92 40.832-33.92zM279.52 382.72c-20.384 0-40.928-13.664-40.928-34.016 0-20.448 20.544-33.92 40.928-33.92 20.352 0 33.92 13.472 33.92 33.92 0 20.384-13.568 34.016-33.92 34.016z"
                fill="currentColor"
                p-id="5410"
              ></path>
              <path
                d="M864 600.352c0-108.672-108.736-197.28-230.88-197.28-129.344 0-231.2 88.576-231.2 197.28 0 108.864 101.856 197.248 231.2 197.248 27.072 0 54.368-6.816 81.568-13.632l74.56 40.8-20.448-67.904C823.328 715.936 864 661.664 864 600.352z m-305.856-34.016c-13.536 0-27.2-13.44-27.2-27.2 0-13.568 13.664-27.2 27.2-27.2 20.576 0 34.016 13.632 34.016 27.2 0 13.76-13.44 27.2-34.016 27.2z m149.536 0c-13.44 0-27.008-13.44-27.008-27.2 0-13.568 13.568-27.2 27.008-27.2 20.352 0 34.016 13.632 34.016 27.2 0 13.76-13.664 27.2-34.016 27.2z"
                fill="currentColor"
                p-id="5411"
              ></path>
            </svg>

            <svg
              v-if="item.type === 'qq'"
              t="1702696631132"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="1733"
              width="22"
              height="22"
              fill="currentColor"
            >
              <path
                d="M824.8 613.2c-16-51.4-34.4-94.6-62.7-165.3C766.5 262.2 689.3 112 511.5 112 331.7 112 256.2 265.2 261 447.9c-28.4 70.8-46.7 113.7-62.7 165.3-34 109.5-23 154.8-14.6 155.8 18 2.2 70.1-82.4 70.1-82.4 0 49 25.2 112.9 79.8 159-26.4 8.1-85.7 29.9-71.6 53.8 11.4 19.3 196.2 12.3 249.5 6.3 53.3 6 238.1 13 249.5-6.3 14.1-23.8-45.3-45.7-71.6-53.8 54.6-46.2 79.8-110.1 79.8-159 0 0 52.1 84.6 70.1 82.4 8.5-1.1 19.5-46.4-14.5-155.8z"
                p-id="1734"
              ></path>
            </svg>

            <svg
              v-if="item.type === 'wb'"
              t="1702861635956"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2441"
              width="22"
              height="22"
              fill="currentColor"
            >
              <path
                d="M434.6 261.4c-63-5.3-209.2 42.5-345.8 265.1 0 0-100.2 180.1 103.7 288.1 0 0 170.2 101.2 410.6 30.1 0 0 243.9-80.7 221.6-249.9 0 0-18.5-70.1-104.7-90.6 0 0-26.6-3.5-11.6-30.1 0 0 38.2-77.9-36.4-110 0 0-66.5-15.9-147.2 24.8 0 0-53.1 30.1-27.6-35.4-0.6-0.8 11.8-85.8-62.6-92.1z m242.9 365.3c0 92.1-118.9 193.3-264.4 193.3-171 0-264.4-74.6-264.4-167.5 0-92.1 134.8-180.9 281-180.9 145.8 0 247.8 63 247.8 155.1z m0 0"
                p-id="2442"
              ></path>
              <path
                d="M530.2 658.8c-4.3 67.3-61.2 119.7-136.6 122.4-91.3 3.5-151.5-38.2-140.9-120.7 8.1-67.3 66.5-124.2 140.9-124.2 75.4 0.1 141.9 40.8 136.6 122.5z m-89.5-18c0-9.9-8.1-17.7-17.7-17.7s-17.7 8.1-17.7 17.7 8.1 17.7 17.7 17.7c9.6 1 17.7-6.8 17.7-17.7z m-47.8 42.8c0-24-22.3-43.5-47.1-40s-48.8 22.3-48.8 46c0 24 20.5 41.7 46 41.7 25.8 1.1 49.9-23.7 49.9-47.7z m279.2-449.5c4.3-1.8 8.1-2.5 12.4-3.5 4.3-0.8 8.9-1.8 14.2-2.5-15.2 1.8-2.5 0.8 0 0 3.5 0 7.1-0.8 11.6-0.8h22.3c4.3 0 8.1 0.8 12.4 0.8-11.6-1.8-3.5-0.8-0.8 0 2.8 0.8 5.3 0.8 8.9 1.8 8.9 1.8 17.7 4.3 26.6 8.1 2.5 0.8 4.3 1.8 7.1 2.5-8.9-3.5-0.8 0 0.8 0 5.3 2.5 10.6 5.3 16.7 8.9 4.3 2.5 9.9 6.1 14.2 8.9 2.5 1.8 4.3 3.5 7.1 5.3-7.1-5.3 0.8 0.8 1.8 1.8 9.9 8.1 18.5 16.7 27.6 26.6 0.8 0.8 7.1 8.9 0.8 0.8 1.8 1.8 2.5 4.3 4.3 6.1 2.5 4.3 5.3 8.9 8.1 12.4 2.5 4.3 4.3 8.9 6.1 13.4 3.5 8.1-2.5-8.1 0 0 0.8 2.5 1.8 5.3 3.5 8.9 2.5 8.1 4.3 16.7 6.1 25.8 0 1.8 0.8 4.3 0.8 6.1-1.8-11.6-0.8-4.3 0-1.8 0.8 4.3 0.8 8.9 0.8 14.2 0 7.1 0 15.2-0.8 22.3 0 3.5-0.8 7.1-0.8 10.6 1.8-14.2 0 0-0.8 2.5-1.8 9.9-4.3 18.5-7.1 27.6-1.8 5.3-8.1 18.5-0.8 2.5-8.1 17.7-5.3 39 13.4 49.6 15.9 8.9 41.7 5.3 49.6-13.4 22.3-48.8 26.6-107.3 11.6-159.6-26.6-94.1-118.9-157.9-213.8-165.7-26.6-1.8-55.9 0-80.7 8.9-18.5 6.1-31.1 24.8-25.8 44.3 2.7 19.5 23.9 33.6 42.6 26.6z m0 0"
                p-id="2443"
              ></path>
              <path
                d="M690.6 335c2.5-0.8 4.3-0.8 7.1-1.8 8.1-1.8-4.3 0 2.5 0 3.5 0 8.1-0.8 11.6-0.8 14.2 0 30.1 3.5 41.7 14.2 1.8 1.8 3.5 3.5 6.1 5.3 0 0 5.3 6.1 2.5 3.5 1.8 1.8 2.5 4.3 3.5 6.1 1 1.8 1.8 2.5 1.8 4.3-0.8-1.8-0.8-1.8 0 0.8 1.8 4.3 2.5 8.9 3.5 13.4 1.8 7.1 0-4.3 0 1.8v18.7c0 1.8 0 3.5-0.8 4.3 0.8-8.1 0-0.8 0 0-0.8 2.5-0.8 5.3-1.8 8.1-3.5 12.4 4.3 26.6 16.7 29.3 13.4 3.5 25.8-4.3 29.3-16.7 12.4-40 2.5-87-29.3-114.3-28.3-25.8-72.9-34.7-110-24-26.9 9.8-13.5 55.9 15.6 47.8z m0 0"
                p-id="2444"
              ></path>
            </svg>

            <svg  v-if="item.type === 'qzone'" t="1702872246719" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6116" width="20" height="20"><path d="M978.773333 402.133333a51.84 51.84 0 0 0-42.666666-35.413333l-260.48-37.973333-116.906667-236.586667a52.053333 52.053333 0 0 0-93.44 0l-116.906667 236.586667L87.466667 366.72a52.053333 52.053333 0 0 0-29.013334 88.96L247.466667 640 202.88 899.84a51.626667 51.626667 0 0 0 21.333333 50.986667 52.266667 52.266667 0 0 0 55.04 4.053333L512 832l233.386667 122.88a52.266667 52.266667 0 0 0 75.733333-55.04L776.533333 640l189.013334-184.106667a51.84 51.84 0 0 0 13.226666-53.76zM536.32 772.906667a52.906667 52.906667 0 0 0-48.64 0l-218.24 114.773333 29.226667-168.533333c39.466667 7.04 176.64 23.893333 423.466666-23.893334l32.853334 192z m192-174.506667a52.48 52.48 0 0 0-14.933333 46.293333l5.973333 35.413334-257.92-12.16L746.666667 445.44a758.826667 758.826667 0 0 0-461.226667 33.493333l286.08 15.146667-270.72 210.986667 10.24-60.373334a52.48 52.48 0 0 0-14.933333-46.293333L119.466667 426.666667 362.666667 390.826667A52.053333 52.053333 0 0 0 402.773333 362.666667L512 141.013333 621.226667 362.666667A52.053333 52.053333 0 0 0 661.333333 390.826667L904.533333 426.666667z" fill="currentColor" p-id="6117"></path></svg>
          </span>
        </el-popover>
      </li>
    </ul>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";

export default {
  props: {
    share: {
      type: Object,
      default: () => {
        return {
          link: "",
          h5: "",
          name: "",
          img: "",
          notice: "",
        };
      },
    },
  },
  data() {
    return {
      code: "",
      shares: [
        {
          type: "link",
          url: "",
          title: "复制链接",
        },
        {
          type: "h5",
          url: "",
          title: "",
        },
        // {
        //   type: 'wx',
        //   url: '',
        //   title: ''
        // },
        // {
        //   type: "qq",
        //   url: "",
        //   title: "QQ分享",
        // },
        // {
        //   type: "qzone",
        //   url: "",
        //   title: "QQ空间分享",
        // },
        // {
        //   type: "wb",
        //   url: "",
        //   title: "微博分享",
        // },
      ],
    };
  },
  mounted() {
    this.getQRCode();
    // this.getWXAppkey()
  

  },
  methods: {
    downloadImage() {

      let  myCanvas = document
        .getElementById("qrcode")
        .getElementsByTagName("canvas");
      var link = document.createElement('a');
      link.href =  myCanvas[0].toDataURL("image/png");
      link.download = '二维码.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    openShare({ type }) {
      switch (type) {
        case "link":
          this.copyLink();
          break;
        case "wb":
          this.weibo();
          break;
        case "qzone":
          this.qzone();
          break;
      }
    },
    getQRCode() {
      this.code = new QRCode("qrcode", {
        width: 100,
        height: 100,
        text: this.share.h5,
      });
      // let terget = this.shares.find(item=> item.type === 'h5')
      // terget.url = this.code._htOption.text
      // console.log(this.code._htOption, 888, this.shares)
    },
    // 复制分享地址
    copyLink(link) {
      let input = document.createElement("input");
      input.value = link ? link : this.share.link;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.$message.success(this.$t("global.copySuccess"));
    },
    qzone() {
      const share = {
        title: this.share.name,
        desc: this.share.notice,
        image_url: this.share.img,
        share_url: this.share.link,
      };

      const shareUrl =
        "https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
        encodeURIComponent(share.share_url) +
        "&sharesource=qzone&title=" +
        share.title +
        "&pics=" +
        share.image_url +
        "&summary=" +
        share.desc;

      // 打开分享链接
      window.open(shareUrl);
    },

    qq() {
      const share = {
        title: this.share.name,
        desc: this.share.notice,
        image_url: this.share.img,
        share_url: this.share.link,
      };
      //传递的参数
      let parameter = `url=${encodeURIComponent(
        share.share_url
      )}&sharesource=qzone&title=${share.title}&pics=${share.image_url}&summary=${
        share.share_url
      }`;

      let urlData = `http://connect.qq.com/widget/shareqq/index.html?${parameter}`;
      window.open(urlData, "_blank");

    },
    weibo() {
      // 替换成你的应用信息
      const appKey = "YOUR_APP_KEY";
      const redirectUri = this.share.link;
      // 分享内容
      const shareContent = this.share.name;
      // 封面图片链接
      const coverImageUrl = this.share.img;

      // 构建分享链接
      let shareUrl = `http://service.weibo.com/share/share.php?appkey=${appKey}&title=${encodeURIComponent(
        shareContent
      )}&url=${encodeURIComponent(redirectUri)}&pic=${encodeURIComponent(coverImageUrl)}#`;

      if(this.share.notice) {
        let text = this.share.notice.length >100 ? this.share.notice.substring(0, 100)+'......' : this.share.notice

         shareUrl = `http://service.weibo.com/share/share.php?appkey=${appKey}&url=${encodeURIComponent(redirectUri)}&title=${encodeURIComponent(
          shareContent
        )}(${encodeURIComponent(
          text
        )})&pic=${encodeURIComponent(coverImageUrl)}`;
      }

      // 打开分享链接
      window.open(shareUrl);
    },
  },
};
</script>

<style lang="scss">
.share- {
  display: flex;
  align-items: center;
  ul {
    display: flex;
    align-items: center;

    li {
      margin: 0 0 0 10px;
      cursor: pointer;

      .el-popover__reference {
        display: flex;
      }
      svg{
        color: #666
      }
    }
  }
}

.share-qrcode {
  width: 100px;
  height: 100px;

  img {
    width: 100%;
    height: 100%;
  }


}

.share-popover {
  width: auto !important;
  min-width: auto !important;
  padding: 5px;
  text-align: center;

  > div {
    text-align: center;
    > img {
      width: 100px;
      height: 100px;
    }
  }

  .qrcode-text{
    margin-top: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
}
</style>
